let activeOptions = {};

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function getStyleProperty(element, property) {
  return window.getComputedStyle(element).getPropertyValue(property);
}

/*
 * Shopify Common JS
 *
 */

if (typeof window.Shopify === "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (let i = 0, count = selector.options.length; i < count; i++) {
    const option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent(`on${eventName}`, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  const method = options.method || "post";
  const params = options.parameters || {};

  const form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (const key in params) {
    const hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options.hideElement || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry() {
    const value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince() {
    const value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler(e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    const raw = opt.getAttribute("data-provinces");
    const provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (let i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions(selector, values) {
    for (let i = 0, count = values.length; i < values.length; i++) {
      const opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class QuantityCounter extends HTMLElement {
  constructor() {
    super();
    this.changeEvent = new Event("change", { bubbles: true });
  }

  connectedCallback() {
    this.counterEl = this.querySelector(".js-counter-quantity");
    this.increaseBtn = this.querySelector(".js-counter-increase");
    this.decreaseBtn = this.querySelector(".js-counter-decrease");

    this.min = parseInt(this.counterEl.min) || 1;
    this.max = parseInt(this.counterEl.max) || 999;

    this.increaseBtn.addEventListener("click", this.onIncrease.bind(this));
    this.decreaseBtn.addEventListener("click", this.onDecrease.bind(this));
  }

  onIncrease() {
    const currentValue = parseInt(this.counterEl.value);
    if (currentValue < this.max) {
      this.updateValue(currentValue + 1);
    }
  }

  onDecrease() {
    const currentValue = parseInt(this.counterEl.value);
    if (this.dataset.cart) this.min = 0;
    if (currentValue > this.min) {
      this.updateValue(currentValue - 1);
    }
  }

  updateValue(value) {
    this.counterEl.value = value;
    this.counterEl.dispatchEvent(this.changeEvent);
  }
}

// Define the custom element
window.customElements.define("quantity-counter", QuantityCounter);

// without under functions main-password doesn't work

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

function toggleTabindex(elements) {
  elements.forEach((el) => {
    const tabindex = el.getAttribute("tabindex");
    el.setAttribute("tabindex", tabindex === "0" ? "-1" : "0");
  });
}

function setTabindex(elements, tabindex) {
  elements.forEach((el) => {
    el.setAttribute("tabindex", tabindex);
  });
}

// Helper function to add multiple event listeners with the same handler
function addEventListeners(element, events, handler) {
  events.forEach((event) => element.addEventListener(event, handler));
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open"),
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open"),
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  const elements = getFocusableElements(container);
  const first = elements[0];
  const last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return;
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  async connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

// ============================================
// FIXED: Strike-through price on ReCharge widget
// ============================================
(function() {
  const priceSelector = ".price-item--regular.wt-product__price__final";
  const widgetSelector = "recharge-subscription-widget";

  // Utility to prevent functions from firing too many times at once
  function debounce(func, wait) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  // 1. Find or create the lower subscription price element
  function getOrCreateSubPriceEl(mainPriceEl) {
    // Look in the parent to see if it already exists
    let subPriceEl = mainPriceEl.parentNode.querySelector('.custom-recharge-sub-price');
    if (!subPriceEl) {
      subPriceEl = document.createElement('span');
      subPriceEl.className = 'custom-recharge-sub-price';
      mainPriceEl.parentNode.insertBefore(subPriceEl, mainPriceEl.nextSibling);
    }
    return subPriceEl;
  }

  // 2. Core Logic: Update Strikethrough and Lower Price
  function updatePriceUI() {
    const mainPriceEl = document.querySelector(priceSelector);
    const widget = document.querySelector(widgetSelector);

    if (!mainPriceEl || !widget || !widget.shadowRoot) return;

    const subPriceEl = getOrCreateSubPriceEl(mainPriceEl);
    const selectedOption = widget.shadowRoot.querySelector('input[name="purchaseOption"]:checked');

    // Check if a subscription option is chosen
    const isSubscription = selectedOption && selectedOption.value !== 'onetime';

    if (isSubscription) {
      mainPriceEl.classList.add("subscription-active");
      subPriceEl.style.display = "inline-block";

      const optionContainer = selectedOption.closest('.rc-purchase-option');
      if (optionContainer) {
        const discountPriceEl = optionContainer.querySelector('[part="rc-purchase-option__discounted-price"]');
        if (discountPriceEl) {
          const clone = discountPriceEl.cloneNode(true);
          const visuallyHidden = clone.querySelector('.visually-hidden');
          if (visuallyHidden) visuallyHidden.remove();
          subPriceEl.innerHTML = clone.textContent.trim();
        }
      }
    } else {
      mainPriceEl.classList.remove("subscription-active");
      if(subPriceEl) subPriceEl.style.display = "none";
    }
  }

  // 3. Watch ReCharge Widget for Clicks
  function observeWidget() {
    const widget = document.querySelector(widgetSelector);
    if (!widget || !widget.shadowRoot) return false;

    const radios = widget.shadowRoot.querySelectorAll('input[name="purchaseOption"]');
    radios.forEach(radio => {
      radio.removeEventListener('change', updatePriceUI);
      radio.addEventListener('change', updatePriceUI);
    });

    // Watch internal widget changes
    new MutationObserver(debounce(updatePriceUI, 100))
      .observe(widget.shadowRoot, { childList: true, subtree: true, characterData: true });

    return true;
  }

  // 4. Watch Shopify Theme for Async Price Swaps (The Vanishing Fix)
  function observeShopifyTheme() {
    // Attach to the body so the observer is never destroyed
    new MutationObserver(debounce((mutations) => {
       let priceWasSwapped = false;
       
       // Check if the mutation happened to our specific price element
       mutations.forEach(mutation => {
         if (mutation.target.closest(priceSelector) || (mutation.target.id && mutation.target.id.includes('price-'))) {
           priceWasSwapped = true;
         }
       });

       if (priceWasSwapped) {
         // Shopify just wiped the price! Re-apply our ReCharge logic immediately.
         setTimeout(updatePriceUI, 50);
         setTimeout(updatePriceUI, 300); // Backup safety net
       }
    }, 50)).observe(document.body, { childList: true, subtree: true });
  }

  // 5. Initialize
  function init() {
    let attempts = 0;
    const interval = setInterval(() => {
      attempts++;
      if (observeWidget() || attempts > 50) {
        clearInterval(interval);
        observeShopifyTheme();
        updatePriceUI();
      }
    }, 100);
  }

  // Start script
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// PDP Shipping timeline calculation
(function() {
  const displayContainer = document.getElementById('shipping-timeline-display');
  const messageElement = document.getElementById('shipping-message');

  if (!displayContainer || !messageElement) return;

  const policyConfig = {
    domesticCountry: "United States",
    domestic: { min: 7, max: 9 },
    international: { min: 17, max: 22 }
  };

  function calculateBusinessDate(startDate, daysToAdd) {
    let date = new Date(startDate);
    let count = 0;
    while (count < daysToAdd) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() !== 0 && date.getDay() !== 6) {
        count++;
      }
    }
    return date;
  }

  fetch(window.Shopify.routes.root + "browsing_context_suggestions.json")
    .then(res => res.json())
    .then(data => {
      const country = data.detected_values.country.name;
      const isDom = (country === policyConfig.domesticCountry);
      
      const minDays = isDom ? policyConfig.domestic.min : policyConfig.international.min;
      const maxDays = isDom ? policyConfig.domestic.max : policyConfig.international.max;

      const today = new Date();
      const start = calculateBusinessDate(today, minDays);
      const end = calculateBusinessDate(today, maxDays);

      const format = { month: 'short', day: 'numeric', year: 'numeric' };
      const startText = start.toLocaleDateString(undefined, format);
      const endText = end.toLocaleDateString(undefined, format);

      messageElement.innerHTML = `Estimated delivery to <strong>${country}</strong>: ${startText} - ${endText}`;
      displayContainer.style.display = 'block';
    })
    .catch(() => {
      displayContainer.style.display = 'none';
    });
})();